import { useLocation } from 'react-router-dom';

export default function useHistoryState<T>(): T {
  const { state } = useLocation();
  return state as T;
}
